import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { GestServComponent } from './components/gest-serv/gest-serv.component';

const routes: Routes = [
  { path: '', component: GestServComponent  },
  { path: '**', redirectTo: '/dashboard', pathMatch: 'full'  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GestServicesRoutingModule { }
